import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  accentText?: string;
}

export default function MovieGrid({ title, subtitle, movies, accentText }: MovieGridProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
              {title}
              {accentText && <span className="text-primary-500"> {accentText}</span>}
            </h2>
            {subtitle && <p className="mt-2 text-sm text-foreground-400">{subtitle}</p>}
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-500/50 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.posterUrl}
          alt={movie.title}
          title={`${movie.title} - 97影院高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {movie.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-semibold rounded whitespace-nowrap">新</span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-foreground-50 text-xs font-semibold rounded whitespace-nowrap">热播</span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-background-950/70 text-accent-500 text-xs font-heading font-bold rounded whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <h3 className="text-sm font-semibold text-foreground-50 line-clamp-1">{movie.title}</h3>
          <div className="flex items-center gap-2 mt-1 text-xs text-foreground-300">
            <span>{movie.year}</span>
            <span className="w-0.5 h-0.5 rounded-full bg-foreground-500"></span>
            <span>{movie.category}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}